// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chevron-down.js';

import { paths } from '../generated/chevron-down';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chevron-down', Original, paths);
